import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';

@Injectable({
	providedIn: 'root'
})
export class INDRAObservatoryService {
	private global = [];
	constructor() {}

	public setData(data, value) {
		if (!this.global[data]) {
			this.global[data] = new BehaviorSubject(value);
		}
		this.global[data].next(value);
	}

	public getData(data) {
		if (!this.global[data]) {
			this.setData(data, '');
		}
		return this.global[data].asObservable();
	}

	public removeData(data) {
		if (_.has(this.global, data)) {
			delete this.global[data];
		}
	}

	public checkData(data) {
		if (this.global[data]) {
			return true;
		}

		return false;
	}
}
